import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../i18n/runtime";
import React from 'react';
import { Globe, Hotel } from 'lucide-react';
import { useCatalog, CatalogStatus, countryName, cityName } from '../context/CatalogContext';
import {visaTypes} from './visaTypes';
export const visaTypeLabel = type => visaTypes[type] || type;
export default function CatalogResults({
  kind
}) {
  __useLocale();
  const {
    hotels,
    visas,
    countries,
    cities,
    hotelFilter,
    visaFilter,
    loading,
    error
  } = useCatalog();
  const isHotel = kind === 'hotel';
  const f = isHotel ? hotelFilter : visaFilter;
  const matches = (isHotel ? hotels : visas).filter(item => {
    if (f.country && countryName(item.country, countries) !== f.country) return false;
    if (!isHotel) return !f.type || item.visa_type === f.type;
    return (!f.city || cityName(item.city, cities) === f.city) && (!f.stars || Number(item.stars) === Number(f.stars)) && (f.minPrice === '' || f.minPrice == null || Number(item.price_per_night) >= Number(f.minPrice)) && (f.maxPrice === '' || f.maxPrice == null || Number(item.price_per_night) <= Number(f.maxPrice));
  });
  return <section id={`${kind}-results`} className={`py-16 px-4 scroll-mt-8 ${isHotel ? 'bg-gray-50' : 'bg-white'}`} dir={__direction()}>
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-12"><h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">{__tr(isHotel ? "الفنادق المتاحة" : "التأشيرات المتاحة")}</h2><p className="text-gray-600 text-lg">{__tr(isHotel ? "استكشف الفنادق وأسعار الإقامة لكل ليلة" : "تعرف على خدمات التأشيرات للدول ومدة إنجازها وأسعارها")}</p></div>
      <CatalogStatus empty={!matches.length} />
      {__tr(!loading && !error && <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {__tr(matches.map(item => <article key={item.id} className="bg-white rounded-2xl overflow-hidden shadow-md border border-gray-100">
          {__tr(isHotel && <div className="aspect-[16/10] bg-purple-100 flex items-center justify-center">
            {__tr(item.images?.[0] ? <img src={item.images[0]} alt={__tr(item.name_ar || item.name_en)} className="w-full h-full object-cover" loading="lazy" /> : <Hotel className="w-16 h-16 text-purple-400" aria-hidden="true" />)}
          </div>)}
          <div className="p-5">
            <div className="flex items-center gap-2 mb-3">{__tr(!isHotel && (item.country_flag ? <span className="text-2xl">{__tr(item.country_flag)}</span> : <Globe className="text-[#6B5B95]" />))}<h3 className="text-xl font-bold">{__tr(__localizedField(item, "name_ar") || item.name_en)}</h3></div>
            <p className="text-gray-600">{isHotel && <>{__tr(__localizedField(cities.find(c => c.code === item.city || c.name === item.city), 'name') || cityName(item.city, cities))}{__tr("، ")}</>}{__tr(__localizedField(countries.find(c => c.value === item.country || c.name === item.country), 'name') || countryName(item.country, countries))}</p>
            {__tr(isHotel ? <><p className="text-amber-600 mt-2">{__tr(item.stars)}{__tr(" نجوم")}</p>{__tr(__localizedField(item, "description_ar") && <p className="text-gray-600 mt-2">{__tr(__localizedField(item, "description_ar"))}</p>)}</> : <>
              <p className="text-gray-600 mt-2">{__tr(visaTypeLabel(item.visa_type))}</p>
              {__tr(item.duration && <p className="text-gray-600 mt-2">{__tr("مدة التأشيرة: ")}{__tr(__localizedField(item, 'duration'))}</p>)}
              {__tr(item.processing_time && <p className="text-gray-600 mt-2">{__tr("مدة الإنجاز: ")}{__tr(__localizedField(item, 'processing_time'))}</p>)}
            </>)}
            <p className="font-bold text-[#6B5B95] mt-3">{__tr(Number(isHotel ? item.price_per_night : item.price).toLocaleString(__direction() === 'rtl' ? 'ar' : 'en'))} {__tr(item.currency)}{__tr(isHotel ? " / ليلة" : '')}</p>
            <a className="block text-center mt-4 bg-[#6B5B95] text-white rounded-lg px-4 py-2" href={`/checkout?type=${kind}&id=${encodeURIComponent(item.id)}`}>{__tr("شراء الآن")}</a>
          </div>
        </article>))}
      </div>)}
    </div>
  </section>;
}
